<template>
  <div
    class=" 
        flex
        w-full
        bg-img
        vx-row
        justify-center 
      "
  >
    <div
      class="
          vx-col
        "
    >
      <vx-card class="vx-card-fsm justify-center items-center">
        <div slot="no-body" class="">
          <div class="p-8 vs-con-loading__container" id="loginSubmitButton">
            <div class="vx-card__title mb-8">
              <div class="flex">
                <h4 class="mb-4 w-full">
                  {{ $t("FindMailPageTitleForStudent") }}
                </h4>
              </div>
              <p>
                {{ $t("Login.StudentTitle") }}
              </p>
            </div>

            <div v-if="!showSmsConfirmPanel && !showMailPanel">
              <ValidationObserver
                tag="form"
                ref="findMailForm"
                v-bind:key="'findMailFormKeyStudent'"
                v-on:submit.prevent
                v-slot="{ invalid }"
              >
                <ValidationProvider
                  :name="$t('Login.StudentNumber')"
                  rules="required|min:8|max:12"
                  v-slot="{ errors }"
                >
                  <vs-input
                    icon="icon icon-user"
                    icon-pack="feather"
                    :label-placeholder="$t('Login.StudentNumber')"
                    v-model="formFindMailData.StudentNumber"
                    v-on:keyup.enter="findMail"
                    class="w-full no-icon-border"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  :name="$t('Login.IdentityNumber')"
                  rules="required|min:7|max:11"
                  v-slot="{ errors }"
                >
                  <vs-input
                    type="text"
                    icon="icon icon-lock"
                    v-on:keyup.enter="findMail"
                    icon-pack="feather"
                    :label-placeholder="$t('Login.IdentityNumber')"
                    v-model="formFindMailData.IdentityNumber"
                    class="w-full mt-6 no-icon-border"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>

                <vs-button
                  class="w-100 my-2 mt-6 vs-con-loading__container"
                  :disabled="invalid"
                  @click="findMail()"
                  >{{ $t("Login.ForgotButton") }}</vs-button
                >
                <vs-divider>{{ $t("Login.Help") }}</vs-divider>
                <div class="flex flex-wrap justify-center my-5">
                  <a href="/forgot/student" target="_blank">{{
                    $t("Login.ForgotMyPassword")
                  }}</a>
                </div>
                <div class="flex flex-wrap justify-center">
                  <a
                    href="https://obs.fsm.edu.tr/oibs/ogrsis/no_query.aspx"
                    target="_blank"
                    >{{ $t("Login.FindMyStudentNumber") }}</a
                  >
                </div>
              </ValidationObserver>
            </div>
            <div
              v-else-if="!showMailPanel && showSmsConfirmPanel && showSmsTimer"
            >
              <ValidationObserver
                tag="form"
                ref="findMailSmsVerifyForm"
                v-on:submit.prevent
                v-slot="{ invalid }"
              >
                <div class="mb-base">
                  <span class="font-semibold"
                    >{{ $t("Login.SendingSms", { phone: smsPhone }) }}
                  </span>
                </div>
                <ValidationProvider
                  :name="$t('Login.SmsCode')"
                  rules="required|length:6"
                  v-bind:key="'smsCodeInputV'"
                  v-slot="{ errors }"
                >
                  <vs-input
                    type="text"
                    v-mask="['######']"
                    icon="icon icon-lock"
                    v-on:keyup.enter="findMailSmsVerify"
                    icon-pack="feather"
                    :label-placeholder="$t('Login.SmsCode')"
                    v-model="formSmsVerify.SmsCode"
                    ref="smsCodeInput"
                    autocomplete="off"
                    class="w-full mt-6 no-icon-border"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
                <vs-button
                  class="
                          float-right
                          my-5
                          mb-5
                          mt-5
                          w-100
                          vs-con-loading__container
                        "
                  :disabled="invalid"
                  @click="findMailSmsVerify()"
                  >{{ $t("Login.ForgotSmsButton") }}</vs-button
                >
                <CountDown
                  v-if="showSmsTimer"
                  :second="smsCounter"
                  :radius="60"
                />
              </ValidationObserver>
            </div>

            <div v-if="showMailPanel">
              <div class="mb-3">
                <span class="font-semibold"
                  >{{ $t("Login.YourMailAddress", { mail: smsMail }) }}
                </span>
              </div>

              <div class="flex flex-wrap justify-between mb-5">
                <router-link :to="'/forgot/student'">{{
                  $t("ForgotPageTitleForStudent")
                }}</router-link>
              </div>

              <div class="social-login flex flex-wrap justify-around">
                <div
                  class="
                      social-login-buttons
                      flex flex-wrap
                      items-center
                      mt-5
                    "
                >
                  <div
                    class="
                        bg-mail-copy
                        pt-3
                        pb-2
                        px-4
                        rounded-lg
                        cursor-pointer
                        mb-4
                        mr-4
                        text-white
                      "
                    v-clipboard:copy="smsMail"
                    v-clipboard:success="onCopyMail"
                  >
                    {{ $t("CopyMail") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
      <vx-card class="vx-card-fsm justify-center items-center">
        <div slot="no-body" class="mt-5 mb-5">
          <div class="p-8">
            <div class="vx-card__title mb-8">
              <div class="flex">
                <h4 class="mb-1 w-full">
                  {{ $t("SSS") }}
                </h4>
              </div>
            </div>
            <vs-collapse accordion type="margin" class="p-0">
              <vs-collapse-item
                v-for="(que, index) in filteredFaq"
                class="faq-bg rounded-lg"
                :class="{ 'mt-0': !index }"
                :key="que.id"
              >
                <div slot="header">
                  <h5>{{ que.question }}</h5>
                </div>
                <p>{{ que.ans }}</p>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Vue from "vue";
import AuthApi from "@/api/auth";
import CountDown from "@/components/countdown/count-down.vue";
var checkSmsCounter = null;

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    CountDown,
  },
  data() {
    return {
      copyrightClass: "",
      localProfile: {},
      autoLogin: false,
      showUsernameForm: true,
      radios1: 1,
      KVKK: true,
      formFindMailData: {
        StudentNumber: "",
        IdentityNumber: "",
        GoogleReCaptchaResponse: "",
      },
      formSmsVerify: {
        UserId: null,
        SmsCode: null,
        GoogleReCaptchaResponse: "",
      },
      userAccounts: [],
      submitBusy: false,
      showWithoutPasswordPanel: false,
      showSmsConfirmPanel: false,
      smsExpiryDate: null,
      smsCounter: 0,
      smsUserId: null,
      smsPhone: null,
      dateNow: null,
      smsMail: null,
      showMailPanel: false,
      formNewData: {
        Token: null,
        Password: "",
        PasswordRe: "",
        GoogleReCaptchaResponse: "",
      },
    };
  },
  computed: {
    filteredFaq() {
      return [
        {
          id: 1,
          question: this.$t("FaqStudent.Q1"),
          ans: this.$t("FaqStudent.A1"),
        },
        {
          id: 2,
          question: this.$t("FaqStudent.Q2"),
          ans: this.$t("FaqStudent.A2"),
        },
      ];
    },
    showSmsTimer() {
      this.dateNow;
      return this.smsExpiryDate && new Date(this.smsExpiryDate) >= new Date();
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isAuthenticated() {
      this.localProfile;
      return this.$auth.isAuthenticated();
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "tr") return { flag: "tr", lang: "Türkçe" };
      else if (locale == "en") return { flag: "en", lang: "English" };
      else if (locale == "ar") return { flag: "ar", lang: "عربي" };
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },
  },
  beforeDestroy() {
    clearInterval(checkSmsCounter);
  },
  async created() {
    setTimeout(() => {
      this.copyrightClass = "show";
    }, 1000);
  },
  methods: {
    onCopyMail() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.smsMail,
        color: "success",
        iconPack: "feather",
        position: "top-center",
        icon: "icon-check-circle",
      });
    },
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      if (locale == "ar") this.$vs.rtl = true;
      else this.$vs.rtl = false;
    },
    async findMailSmsVerify() {
      const isValid = await this.$refs.findMailSmsVerifyForm.validate();
      if (this.submitBusy || !isValid) return;
      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: "#loginSubmitButton",
        scale: 0.45,
      });

      try {
        this.formSmsVerify.UserId = this.smsUserId;
        let response = await AuthApi.findMailSmsVerifyForStudent(
          this.formSmsVerify,
          this
        );

        setTimeout(() => {
          this.$vs.loading.close(".con-vs-loading");
        }, 100);

        if (!response.data.error) {
          this.showSmsConfirmPanel = false;
          this.smsExpiryDate = null;
          this.smsUserId = null;
          this.smsPhone = null;
          this.smsMail = response.data.Mail;
          this.showMailPanel = true;
        }
      } finally {
        this.submitBusy = false;
      }
    },
    async findMail() {
      const isValid = await this.$refs.findMailForm.validate();
      if (this.submitBusy || !isValid) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: "#loginSubmitButton",
        scale: 0.45,
      });
      try {
        this.$recaptcha("login").then(async (token) => {
          this.formFindMailData.GoogleReCaptchaResponse = token;
          let response = await AuthApi.findMailForStudent(
            this.formFindMailData,
            this
          );

          setTimeout(() => {
            this.$vs.loading.close(".con-vs-loading");
          }, 100);

          if (!response.data.error) {
            this.smsExpiryDate = response.data.SmsCodeValidTime;
            this.smsCounter = response.data.TotalSecond;
            this.smsUserId = response.data.UserId;
            this.smsPhone = response.data.PhoneNumber;
            this.showSmsConfirmPanel = true;
            checkSmsCounter = setInterval(() => {
              this.dateNow = new Date();
              if (!this.showSmsTimer) {
                clearInterval(checkSmsCounter);
                this.formSmsVerify = {
                  UserId: null,
                  SmsCode: "",
                  GoogleReCaptchaResponse: "",
                };
                this.formFindMailData = {
                  StudentNumber: "",
                  IdentityNumber: "",
                  GoogleReCaptchaResponse: "",
                };
                this.showSmsConfirmPanel = false;
                this.smsExpiryDate = null;
                this.smsUserId = null;
                this.smsPhone = null;
              }
            }, 1000);
          }
        });
      } catch {
        setTimeout(() => {
          this.$vs.loading.close(".con-vs-loading");
        }, 100);
      } finally {
        this.submitBusy = false;
      }
    },
  },
};
</script>

<style lang="scss">
.full-page-bg-color {
  background: white !important;
}

.vx-card-fsm {
  border-radius: 1.5rem;
}
.light-shadow {
  .vx-card:hover {
    box-shadow: unset !important;
  }
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

#login-loader {
  width: 16px;
  height: 16px;
  float: left;
  margin-right: 5px;
}
</style>

<style lang="scss">
.count-down {
  display: table;
  margin: 0 auto;
  cursor: default;
  pointer-events: none;
  .percent {
    position: relative;
    &-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #26c68a;
      font-size: 50px;
      line-height: 1;
      font-weight: bold;
      transition: all 0.5s linear;
    }
    svg {
      margin: 0 auto;
      position: relative;
      display: flex;
      circle {
        width: 100%;
        height: 100%;
        fill: none;
        stroke: #fff;
        stroke-width: 10;
        stroke-linecap: round;
        transform: translate(5px, 5px);
        &:last-child {
          stroke: #21cf90;
          transition: all 0.1s linear;
          position: absolute;
          transform: translate(5px, -5px) rotate(-90deg);
          transform-origin: center center;
        }
      }
    }
  }
}
.w-100 {
  width: 100%;
}

.social-login {
  .bg-mail-copy {
    background-color: #4285f4;
  }
}

.vx-card-fsm {
  max-width: 423px;
  width: 100vh;
}

@media (max-width: 450px) {
  .vx-card-fsm {
    width: 100% !important;
  }
}
</style>
